// extracted by mini-css-extract-plugin
module.exports = {"toHit":"CharacterSheetWeapon_toHit_2jcpu","damage":"CharacterSheetWeapon_damage_DPjg4"};